import { Box, BoxProps, Typography } from '@mui/material';

import { type InputState } from '../../utils/inputState';
import { AxleTextField, AxleTextFieldProps } from '../formFields/AxleTextField';
import { NoneLabel } from '../labels/NoneLabel';
import {
    LeftRailNoneLabel,
    LeftRailValueTypography,
} from '../patients/PatientLeftRail/PatientLeftRail';

export function NotesDisplay({
    notes,
    whiteBackground = false,
}: {
    notes: string | null;
    whiteBackground?: boolean;
}) {
    return (
        <Box
            sx={{
                p: 1,
                backgroundColor: whiteBackground ? '#fff' : '#fafafa',
                border: '1px solid #f3f3f3',
                borderRadius: 0.5,
                overflowWrap: 'break-word',
            }}
        >
            {notes ? (
                <Typography sx={{ whiteSpace: 'pre-wrap' }}>{notes}</Typography>
            ) : (
                <NoneLabel />
            )}
        </Box>
    );
}

type NotesInputProps = BoxProps & {
    notes: InputState<string>;
    readOnly?: boolean;
    _extraInputProps?: AxleTextFieldProps['_extraInputProps'];
};
export const NotesInput = ({
    notes,
    readOnly = false,
    _extraInputProps,
    ...rest
}: NotesInputProps) => {
    return (
        <Box
            sx={{
                backgroundColor: '#fafafa',
                borderRadius: '8px',
                overflowWrap: 'break-word',
            }}
            {...rest}
        >
            {readOnly ? (
                notes.value ? (
                    <LeftRailValueTypography
                        sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}
                    >
                        {notes.value}
                    </LeftRailValueTypography>
                ) : (
                    <LeftRailNoneLabel />
                )
            ) : (
                <AxleTextField
                    inputState={notes}
                    multiline={true}
                    _extraInputProps={_extraInputProps}
                />
            )}
        </Box>
    );
};
